import { TAB_NAME, SWITCH_HAM, SET_TODAY } from "../Actions/PannelAction";

const initialState = {
  tabName: "داشبورد",
  hamburgerMenu: false,
  today: null,
};

const PannelReducer = (state = initialState, action) => {
  switch (action.type) {
    case TAB_NAME:
      return { ...state, tabName: action.payload };
    case SWITCH_HAM:
      return { ...state, hamburgerMenu: !state.hamburgerMenu };
    case SET_TODAY:
      return { ...state, today: action.payload };
    default:
      return state;
  }
};
export default PannelReducer;
